import API from "../Common/Endpoint/serviceConstrants";
import axiosInstance from "../Common/Axios/axiosInstance";
export const loginAuthApi = async (payload) => {
    const { data = {} } = await axiosInstance.post(API.loginAuth, payload, {
      headers: {
        ...axiosInstance.defaults.headers,
        Userid: process.env.REACT_APP_U_N,
        Password: process.env.REACT_APP_U_PP,
      },
    });
  return data;
};
